export default __webpack_public_path__ + "static/media/icon-instagram.3d55f9f3.svg";